
import React, { useState } from 'react';
import { Navigate } from "react-router-dom";
import {
  Tooltip,
} from "@mui/material";

import {
  Background,
  Condition,
  Creature,
  DandDFeatureSource,
  EldritchInvocation,
  Feat,
  FightingStyle,
  GameClass,
  Gift,
  // MagicItem,
  MagicItemKeyword,
  OrgPosition,
  PactBoon,
  Race,
  Subclass,
  Subrace
} from "@dndModels";

import API from "@dndUtilities/system_api";

import CopyButton from "@components/input/buttons/CopyButton";
import { DataType, isDataType } from '@dndModels/Types';

interface Props {
  copyMe: DandDFeatureSource | Creature;
  special_copy_type: DataType | "";
  processing: boolean;
  setProcessing: (changed: boolean) => void;
}

export default function BackgroundIndex({
  copyMe,
  special_copy_type,
  processing,
  setProcessing
}: Props) {
  const [navigateTo, setNavigateTo] = useState<string | null>(null);

  const api = API.getInstance();

  if (navigateTo !== null) {
    return <Navigate to={navigateTo} />;
  } else {
    return (
      <Tooltip title={`Copy ${copyMe.name} to Selected Type`}>
        <span>
          <CopyButton
            label={`Selected Type`}
            disabled={
              special_copy_type === "" ||
              processing ||
              // disabled ||
              // view_only || 
              api.user === null ||
              !(api.user.admin ||
                copyMe.owner_id === api.user._id
              )
            }
            onClick={() => {
              if (isDataType(special_copy_type)) {
                setProcessing(true);
                // onProcessingChange(false);
                const user = api.user;
                if (user) {
                  let new_obj = new DandDFeatureSource();
                  switch (special_copy_type) {
                    case "background":
                      new_obj = new Background();
                    break;
                    case "condition":
                      new_obj = new Condition();
                    break;
                    case "eldritch_invocation":
                      new_obj = new EldritchInvocation();
                    break;
                    case "feat":
                      new_obj = new Feat();
                    break;
                    case "fighting_style":
                      new_obj = new FightingStyle();
                    break;
                    case "game_class":
                      new_obj = new GameClass();
                    break;
                    case "gift":
                      new_obj = new Gift();
                    break;
                    case "pact_boon":
                      new_obj = new PactBoon();
                    break;
                    case "race":
                      new_obj = new Race();
                    break;
                    case "subclass":
                      new_obj = new Subclass();
                    break;
                    case "subrace":
                      new_obj = new Subrace();
                    break;
                    // case "magic_item":
                    //   new_obj = new MagicItem();
                    // break;
                    case "magic_item_keyword":
                      new_obj = new MagicItemKeyword();
                    break;
                    case "org_position":
                      new_obj = new OrgPosition();
                    break;
                  }
                  new_obj.specialCopy(copyMe);
                  if (!user.admin) {
                    new_obj.owner_id = user._id;
                    new_obj.source_books_old = [{ type: "Homebrew", id: user._id, third_party: false }];
                  }
                  if (api.user && api.user.admin) {
                    api.applyWorkingOn(new_obj);
                  }
                  api.createObject(special_copy_type, new_obj).then(res => {
                    setProcessing(false);
                    // onProcessingChange(false);
                    if (res) {
                      setNavigateTo(`/dandd/${special_copy_type}/edit/${res.body.id}`);
                    }
                  });
                }
              }
            }}
          />
        </span>
      </Tooltip>
    );
  }
}
